import {CookieManager} from '../common/cookieManager';
import {notNull} from '../../../../vendor/plugins/clxMobileNetPortable/assets/responsive/js/common/assert';
import {SlButton} from '@shoelace-style/shoelace/shoelace';

export class CheaperDialog {
    private readonly cookieManager: CookieManager;
    private readonly cookieCheaperLayerDismissed = 'CHEAPER_LAYER_DISMISSED';

    constructor() {
        this.cookieManager = new CookieManager();
        this.cheaperLayerEventListeners();
    }

    private cheaperLayerEventListeners(): void {
        const cheaperLayer = document.querySelector('.tooltip-cheaper');
        if (!cheaperLayer) {
            return;
        }

        const closeIcon = cheaperLayer.querySelector('sl-button.tooltip-cheaper-close-link') as SlButton;
        closeIcon?.addEventListener('click', (e) => {
            cheaperLayer.classList.remove('open');
            this.setCookie();
            e.preventDefault();
        });

        const button = cheaperLayer.querySelector('sl-button.show-more') as SlButton;
        button?.addEventListener('click', () => {
            this.setCookie();
        });

        const merklistLink = document.querySelector('#link-merklist') as HTMLAnchorElement;
        merklistLink?.addEventListener('click', () => {
            this.setCookie();
        });

        // nur 1 mal anzeigen
        if (this.cookieManager.getCookie(this.cookieCheaperLayerDismissed)) {
            return;
        }

        cheaperLayer.classList.add('open');
    }

    private setCookie() {
        this.cookieManager.setCookie(this.cookieCheaperLayerDismissed, 'true', 1);
    }
}
